<app-dvs-chart #chart [options]="vshaft?.plotOptions" loading="Loading vibration data..." [height]="'600px'"></app-dvs-chart>
@if (vshaft?.plotOptions) {
	<div class="chart-legend">
		<span #avgLegend class="legend-item" [class.interactive]="!disableInteractive" (click)="togglePointVisible(avgLabel)" (mouseenter)="setPointHover(avgLabel, true)"
			(mouseleave)="setPointHover(avgLabel, false)">
			<span class="swatch square"></span> {{avgLabel}}
		</span>
		<span #predLegend class="legend-item" [class.interactive]="!disableInteractive" (click)="togglePointVisible(predLabel)" (mouseenter)="setPointHover(predLabel, true)"
			(mouseleave)="setPointHover(predLabel, false)">
			<span class="swatch diamond"></span> {{predLabel}}
		</span>
	</div>
}
@if (!disableDownload) {
	<button (click)="DownloadData(vshaft)" title="Download a text output of the RTB average and predictions" class="button block mt-3">Download CSV</button>
}